module.exports = __webpack_public_path__ + "static/BeVietnam-Regular-2648213a062438eb4ab588b855b2ded2.woff";